import { isFilledArray } from '@src/helpers/validation/arrayValidators';

export function newSideNavPermissions(pillars:string[], validPermissions: any, currentRoute: string){

    const route = validPermissions.find((e: any) => `/${e.route}` === currentRoute && e.canAccess)
    return route ? true : false
}

export function newPagePermissions(type: string[], roles: string[]){
    return true;
}